export default __webpack_public_path__ + "static/media/visa-card.9f51c63d.png";